import { createContext, useContext } from "react";
import { CompetitionCategory } from "@/app/redux/features/categories/slice";
import { CompetitionData } from "@/app/components/ActiveCompetitions/types";
import { CompetitionPrizeTypes } from "@/app/(general-header)/management-subscription/types";

export const SubscriptionCompetitionsPrizesPageContext = createContext<{
  competitionDetails: SubscriptionCompetitionDetails;
  isAlreadySubscribed: boolean;
  category: CompetitionCategory;
  isCompetitionDetailsLoading: boolean;
  activeCompetition: CompetitionData;
  openTabContent: (e: React.MouseEvent<HTMLElement>, activeTab: number) => void;
  onViewPlansClick: (place?: string) => void;
  lobbyContent: SubscriptionLobbyContent;
  isLobbyContentLoading: boolean;
  prizeStraplineTexts: CompetitionPrizeTypes;
  isPrizeStraplineTextsLoading: boolean;
  subscriptionPackages: Package[];
}>({
  competitionDetails: { prizes: [], promoHeaderImageUrls: [], infoPopupContent: "" },
  isAlreadySubscribed: false,
  category: {
    competitions: [],
    imageUrl: "",
    subtitle: "",
    title: "",
    type: "",
  },
  isCompetitionDetailsLoading: true,
  activeCompetition: {
    AdditionalCashText: "",
    CompetitionId: 0,
    CompetitionPictureTypeId: 0,
    CtaAddToBasketPrizeId: 0,
    CtaText: "",
    CtaTextValidated: "",
    CtaTicketValue: "",
    CurrencySymbol: "",
    EndDateTime: "",
    EndDate: "",
    FormattedOriginalPrice: "",
    FormattedPrice: "",
    FormattedPriceWithoutCurrency: "",
    HasInstantWin: false,
    ImageDoubleUrl: "",
    ImageUrl: "",
    IsRewardCompetition: false,
    IsSinglePrizeMode: false,
    MultiBuyLowerPercent: 0,
    MultiBuyLowerQuantity: 0,
    MultiBuyUpperPercent: 0,
    MultiBuyUpperQuantity: 0,
    NavigationColour: "",
    OverrideDiscountValue: 0,
    PageUrl: "",
    PercentOffValue: 0,
    PostalEntryText: "",
    SupportsMultibuy: false,
    TicketText: "",
    Title: "",
    UseDailyPopupForCompetitionId: 0,
    SubtitleTextValidated: "",
    SubtitleText: "",
    OverrideCompetitionTypeId: null,
    CompetitionTypePrefix: "",
    IsMultibuyEnabled: false,
    IsMobileAppOnly: false,
    IsMobileOnlyCompetition: false,
    FeaturedPrizeId: 0,
    FeaturedPrizeModel: "",
    MobileTitle: "",
    FeaturedPrizeThumbnail: "",
  },
  openTabContent: null,
  onViewPlansClick: null,
  lobbyContent: {
    pastWinnerEndDate: "",
    pastWinnerStartDate: "",
    subSubcribedHeader: { disclaimer: "", subtitle: "", title: "" },
    unsubSubcribedHeader: { perks: [], subtitle: "", title: "" },
    youveEntered: [],
  },
  isLobbyContentLoading: true,
  prizeStraplineTexts: {
    PrizeStraplineText1: "",
    PrizeStraplineText2: "",
    PrizeStraplineText3: "",
  },
  isPrizeStraplineTextsLoading: true,
  subscriptionPackages: [],
});

export const useSubscriptionCompetitionsPrizesPageContext = () => useContext(SubscriptionCompetitionsPrizesPageContext);
